import React, { useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { fetchArts } from "../../redux/slices/articulosSlice";

import Header from "../../components/layout/Header";
import Miniaturas from "../../components/Miniaturas";
import Loading from "../../components/Loading";
import { useParams } from "react-router-dom";

const Results = () => {
  const [showLoading, setShowLoading] = React.useState(true);

  const dispatch = useDispatch();
  const articulos = useSelector((state) => state.articulos.articulos);

  const { search } = useParams();

  const handleFilterArticulos = (value = "") => {
    if (value === "" || value === undefined) return articulos;

    const filter = articulos.filter((articulo) => {
      const nombreEnMinusculas = articulo.nombre.toLowerCase();
      return nombreEnMinusculas.includes(value.toLowerCase());
    });

    return filter;
  };

  useEffect(() => {
    dispatch(fetchArts());
  }, [dispatch]);

  useEffect(() => {
    document.title = "Resultados";
    window.scrollTo(0, 0);

    setShowLoading(true);
    if (articulos.length > 0) {
      setShowLoading(false);
      window.scrollTo(0, 0);
      return;
    }
  }, [setShowLoading, dispatch, articulos]);

  return (
    <Fragment>
      {showLoading ? (
        <Loading />
      ) : (
        <>
          <Header
            showHeader
            showBtnBack
            menuType={false}
            listado={[]}
            actual={"Resultados"}
          />
          <div className="content secondary">
            <div className="container">
              <Miniaturas
                title={
                  handleFilterArticulos(search) > 0
                    ? "Resultados"
                    : "Sin resultados"
                }
                listArticulos={handleFilterArticulos(search)}
                showPrice={false}
                catSelect={"Resultados"}
              />
            </div>
          </div>
        </>
      )}
    </Fragment>
  );
};

export default Results;
